(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mutao-aufbau-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mutao-responsive-video')) {
    customElements.define('mutao-responsive-video', class extends HTMLElement {
      connectedCallback() {
        if (this._controller) return;
        this._controller = new AbortController();
        this._breakpoint = window.matchMedia('(min-width: 700px)');
        const { signal } = this._controller;
        const pauseHidden = () => this._pauseHiddenVariant();
        this._breakpoint.addEventListener('change', pauseHidden, { signal });
        // Also catch native playback that finishes starting after a viewport change.
        this.addEventListener('media:play', pauseHidden, { signal });
        this._pauseHiddenVariant();
      }

      disconnectedCallback() {
        this._controller?.abort();
        this._controller = null;
        this._breakpoint = null;
      }

      _pauseHiddenVariant() {
        const hiddenVariant = this._breakpoint.matches ? 'mobile' : 'desktop';
        for (const media of this.querySelectorAll(`.mutao-aufbau-video__variant--${hiddenVariant} video-media[playing]`)) {
          media.pause();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mutao-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mutao-before-after')) {
    customElements.define('mutao-before-after', class extends HTMLElement {
      constructor() {
        super();
        this._onSwatchChange = this._onSwatchChange.bind(this);
      }

      connectedCallback() {
        this.addEventListener('swatch:change', this._onSwatchChange);
        // Liquid owns first render; only an interrupted selection needs resuming.
        if (this._pendingSwap) {
          this._swap(this.querySelector('[role="radio"][aria-checked="true"]'), false);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('swatch:change', this._onSwatchChange);
        clearTimeout(this._fadeTimer);
        this._fadeTimer = null;
      }

      _onSwatchChange(event) {
        // The shared radiogroup keeps its keyboard and initial-event contract.
        if (event.target.closest('mutao-before-after') !== this || event.detail.initial) return;
        this._swap(event.detail.button);
      }

      _swap(btn, animate = true) {
        const picture = this.querySelector('[data-mba-after-picture]');
        const imgEl = picture?.querySelector('img');
        const badgeEl = this.querySelector('[data-mba-after-badge]');
        if (!picture || !imgEl || !btn) return;

        // Liquid resolves every finish against the section basis, including empty labels.
        const afterSrc = btn.dataset.afterSrc;
        const afterSrcset = btn.dataset.afterSrcset;
        const afterMobileSrcset = btn.dataset.afterMobileSrcset;
        const afterLabel = btn.dataset.afterLabel || '';

        clearTimeout(this._fadeTimer);
        this._fadeTimer = null;
        this._pendingSwap = true;

        const applySwap = () => {
          if (!this.isConnected) return;
          if (afterSrc) {
            imgEl.srcset = afterSrcset || '';
            imgEl.src = afterSrc;
            imgEl.setAttribute('width', btn.dataset.afterWidth);
            imgEl.setAttribute('height', btn.dataset.afterHeight);
            imgEl.alt = btn.dataset.afterAlt || '';
          }
          let source = picture.querySelector('[data-mba-after-source]');
          if (afterMobileSrcset) {
            if (!source) {
              source = document.createElement('source');
              source.dataset.mbaAfterSource = '';
              source.media = '(max-width: 699px)';
              picture.prepend(source);
            }
            source.srcset = afterMobileSrcset;
            source.sizes = imgEl.sizes;
            source.setAttribute('width', btn.dataset.afterMobileWidth);
            source.setAttribute('height', btn.dataset.afterMobileHeight);
          } else {
            source?.remove();
          }
          if (badgeEl) {
            badgeEl.textContent = afterLabel;
            badgeEl.hidden = !afterLabel;
          }
          picture.style.opacity = '1';
          this._pendingSwap = false;
        };

        if (!animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          picture.style.transition = 'none';
          applySwap();
        } else {
          picture.style.opacity = '0';
          picture.style.transition = 'opacity .2s ease';
          this._fadeTimer = setTimeout(() => {
            this._fadeTimer = null;
            applySwap();
          }, 120);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mutao-journal-feed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mutao-journal-feed')) {
    customElements.define('mutao-journal-feed', class extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        if (document.readyState === 'loading') {
          this._onReady = () => {
            this._onReady = null;
            this._initialize();
          };
          document.addEventListener('DOMContentLoaded', this._onReady, { once: true });
        } else {
          this._initialize();
        }
      }
      disconnectedCallback() {
        if (this._onReady) {
          document.removeEventListener('DOMContentLoaded', this._onReady);
          this._onReady = null;
        }
      }
      _initialize() {
        if (!this.isConnected || this._initialized) return;
        // Empty feeds are valid. Delegation also handles content inserted later.
        this.addEventListener('click', (e) => {
          const pill = e.target.closest('[data-filter]');
          if (pill && pill.closest('mutao-journal-feed') === this) this.apply(pill);
        });
        this._initialized = true;
      }
      apply(pill) {
        const own = (selector) => Array.from(this.querySelectorAll(selector))
          .filter((element) => element.closest('mutao-journal-feed') === this);
        this.pills = own('[data-filter]');
        this.cards = own('[data-cat]');
        this.empty = own('[data-empty]')[0];
        const cat = pill.dataset.filter;
        const showAll = pill.hasAttribute('data-show-all');
        this.pills.forEach(p => p.setAttribute('aria-pressed', String(p === pill)));
        let shown = 0;
        this.cards.forEach(c => {
          const ok = showAll || c.dataset.cat.split(',').includes(cat);
          c.hidden = !ok; if (ok) shown++;
        });
        if (this.empty) this.empty.hidden = shown > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mutao-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mutao-product-grid')) {
    customElements.define('mutao-product-grid', class extends HTMLElement {
      connectedCallback() {
        if (this._controller || this.dataset.studioMode !== 'true') return;
        this._controller = new AbortController();
        this._cards = new Map();
        const { signal } = this._controller;
        // Delegation also covers children parsed or inserted after connection.
        for (const type of ['touchstart', 'touchend', 'touchmove', 'touchcancel']) {
          this.addEventListener(type, event => {
            const card = this._cardFor(event);
            if (!card) return;
            if (type === 'touchstart') {
              this._clearHover(card);
              this._cards.get(card).touching = true;
              card.classList.add('is-hovered');
            } else if (type === 'touchend') {
              const state = this._cards.get(card);
              if (!state?.touching) return;
              state.touching = false;
              clearTimeout(state.resetTimer);
              state.resetTimer = setTimeout(() => this._clearHover(card), 1200);
            } else {
              // Any movement ends the tap preview; native scrolling stays passive.
              this._clearHover(card);
            }
          }, { passive: true, signal });
        }

        // Capture the non-bubbling media events without handling child enters/leaves.
        for (const type of ['mouseenter', 'mouseleave']) {
          this.addEventListener(type, event => {
            if (!event.target.matches('.mutao-pg-card__studio-media')) return;
            const card = this._cardFor(event);
            if (!card) return;
            this._clearHover(card);
            if (type === 'mouseenter') card.classList.add('is-hovered');
          }, { capture: true, signal });
        }
      }

      disconnectedCallback() {
        if (!this._controller) return;
        for (const card of this._cards.keys()) this._clearHover(card);
        this._controller.abort();
        this._cards.clear();
        this._controller = null;
      }

      _cardFor(event) {
        if (!event.target.closest('.mutao-pg-card__studio-media')) return;
        const card = event.target.closest('.mutao-pg-card--studio');
        if (!card || card.closest('mutao-product-grid') !== this) return;
        if (!card.querySelector('.mutao-pg-card__studio-media')) return;
        return card;
      }

      _clearHover(card) {
        let state = this._cards.get(card);
        if (!state) {
          state = {};
          this._cards.set(card, state);
        }
        clearTimeout(state.resetTimer);
        state.resetTimer = null;
        state.touching = false;
        card.classList.remove('is-hovered');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mutao-product-strecke"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mutao-product-strecke')) {
    customElements.define('mutao-product-strecke', class extends HTMLElement {
      connectedCallback() {
        if (this._controller || this.dataset.hoverSwap !== 'true') return;
        this._controller = new AbortController();
        this._cards = new Map();
        const { signal } = this._controller;
        // Delegation also covers children parsed or inserted after connection.
        for (const type of ['touchstart', 'touchend', 'touchmove', 'touchcancel']) {
          this.addEventListener(type, event => {
            const card = this._cardFor(event);
            if (!card) return;
            if (type === 'touchstart') {
              this._clearHover(card);
              this._cards.get(card).touching = true;
              card.classList.add('is-hovered');
            } else if (type === 'touchend') {
              const state = this._cards.get(card);
              if (!state?.touching) return;
              state.touching = false;
              clearTimeout(state.resetTimer);
              state.resetTimer = setTimeout(() => this._clearHover(card), 1200);
            } else {
              // Any movement ends the tap preview; native scrolling stays passive.
              this._clearHover(card);
            }
          }, { passive: true, signal });
        }
      }

      disconnectedCallback() {
        if (!this._controller) return;
        for (const card of this._cards.keys()) this._clearHover(card);
        this._controller.abort();
        this._cards.clear();
        this._controller = null;
      }

      _cardFor(event) {
        // The overlay link bubbles to its row, not to the sibling media.
        const card = event.target.closest('.mutao-strecke-row');
        if (!card || card.closest('mutao-product-strecke') !== this) return;
        if (!card.querySelector('.mutao-strecke-row__media')) return;
        if (!card.querySelector('.mutao-strecke-row__hover-img')) return;
        return card;
      }

      _clearHover(card) {
        let state = this._cards.get(card);
        if (!state) {
          state = {};
          this._cards.set(card, state);
        }
        clearTimeout(state.resetTimer);
        state.resetTimer = null;
        state.touching = false;
        card.classList.remove('is-hovered');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mutao-weg"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('mutao-weg')) return;

  class MutaoWeg extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      if (document.readyState === 'loading') {
        this._onReady = () => {
          this._onReady = null;
          this._initialize();
        };
        document.addEventListener('DOMContentLoaded', this._onReady, { once: true });
      } else {
        this._initialize();
      }
    }

    disconnectedCallback() {
      if (this._onReady) {
        document.removeEventListener('DOMContentLoaded', this._onReady);
        this._onReady = null;
      }
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      // Root listeners remain attached exactly once across reconnects.
    }

    _initialize() {
      if (!this.isConnected || this._initialized) return;
      const own = (selector) => Array.from(this.querySelectorAll(selector))
        .filter((element) => element.closest('mutao-weg') === this);
      this._tabs = own('[data-path-tab]');
      this._panels = own('[data-path-panel]');
      if (!['raw', 'haus'].every((path) =>
        this._tabs.some((tab) => tab.dataset.pathTab === path) &&
        this._panels.some((panel) => panel.dataset.pathPanel === path))) {
        if (!this._observer) {
          this._observer = new MutationObserver(() => this._initialize());
          this._observer.observe(this, { childList: true, subtree: true });
        }
        return;
      }
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      this._reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._wraps = own('[data-haus-img]');
      this._hausMedia = own('.mutao-weg__media--haus')[0];
      this._selectedLabel = own('[data-haus-selected]')[0];
      this._whenSpans = own('[data-when-path]');
      this._hint = own('.mutao-weg__hint')[0];
      this._nudge = own('[data-path-nudge]')[0];

      this.addEventListener('swatch:change', (e) => {
        if (e.target.closest('mutao-weg') === this) this._applyHaus(e.detail.button);
      });
      this.addEventListener('click', (e) => {
        const control = e.target.closest('[data-path-tab], [data-path-nudge]');
        if (!control || control.closest('mutao-weg') !== this) return;
        this._setPath(control.hasAttribute('data-path-tab')
          ? control.dataset.pathTab
          : this.classList.contains('is-path-raw') ? 'haus' : 'raw');
      });
      this._initialized = true;
      this._setPath(this.classList.contains('is-path-haus') ? 'haus' : 'raw');
      // The shared asset may have emitted its initial event before this section loaded.
      const selected = own('mutao-swatch-radiogroup [aria-checked="true"]')[0];
      if (selected) this._applyHaus(selected);
      this.classList.add('is-hydrated');
    }

    _setPath(path) {
      this.classList.toggle('is-path-raw', path === 'raw');
      this.classList.toggle('is-path-haus', path === 'haus');
      this._tabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', tab.dataset.pathTab === path ? 'true' : 'false');
      });
      this._panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.pathPanel === path);
      });
      this._whenSpans.forEach((span) => {
        span.hidden = span.dataset.whenPath !== path;
      });
      // Container ohne Text fuer den aktiven Pfad ganz verstecken
      // (sonst leerer klickbarer Nudge-Button / leere Hint-Zeile)
      [this._hint, this._nudge].forEach((el) => {
        if (!el) return;
        el.hidden = !el.querySelector('[data-when-path="' + path + '"]');
      });
    }

    _applyHaus(btn) {
      if (this._reduced) {
        this._wraps.forEach((w) => { w.style.transition = 'none'; });
      }

      // Foto vorhanden -> Crossfade-Swap; sonst Basisbild + Tint-Fallback
      const hasImg = btn.dataset.hausHasImage === 'true';
      this._wraps.forEach((wrap) => {
        const target = hasImg ? btn.dataset.hausId : 'base';
        wrap.classList.toggle('is-active', wrap.dataset.hausImg === target);
      });
      if (this._hausMedia) {
        this._hausMedia.classList.toggle('is-tinted', !hasImg);
        if (!hasImg) {
          this._hausMedia.style.setProperty('--mwg-tint', btn.dataset.hausColor || 'transparent');
        }
      }
      if (this._selectedLabel) this._selectedLabel.textContent = btn.dataset.hausLabel || '';
    }
  }

  customElements.define('mutao-weg', MutaoWeg);
})();

  } catch(e) { console.error(e); }
})();
})();
